import {Component, Input, ViewEncapsulation} from '@angular/core';

export interface SegmentedTab {
  label: string;
  link: string;
}

@Component({
  selector: 'app-segmented-tabs',
  templateUrl: './segmented-tabs.component.html',
  styleUrls: ['./segmented-tabs.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false
})
export class SegmentedTabsComponent {
  @Input() tabs: SegmentedTab[] = [];
  @Input() activeTab = 0;
  @Input() ariaLabel = 'Sections';

  isActive(index: number): boolean {
    return Number(this.activeTab) === index;
  }
}
